import { FunctionComponent } from 'react';
import { Box, FelaCSS, InputV2 } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import { InputProps } from '../../../../components/bbcommon/input/input';
import IconCalendar from '../../../../components/svg/icon-calendar';
import componentStyles from './input-datepicker-v2.style';

interface IProps extends InputProps {
  inputStyles?: FelaCSS;
}

const InputDatepickerV2: FunctionComponent<IProps> = ({ inputStyles = {}, ...props }) => {
  const styles = componentStyles(props.variant);
  return (
    <InputV2
      style={mergeStyles([styles.input, inputStyles])}
      afterInput={
        props.variant !== 'borderless' ? (
          <Box style={styles.icon}>
            <IconCalendar width={18} color="white" />
          </Box>
        ) : null
      }
      readOnly
      {...props}
    />
  );
};

export default InputDatepickerV2;
